import { mdarsUserManualUrl } from '../../constants'
import { systemRequirementsUrl } from '../../constants'
import { mdarsIIRequirementsUrl } from '../../constants'
import { densoManualUrl } from '../../constants'
import { mdarsDownloadInstructionsUrl } from '../../constants'
import { mdarsProgrammingManualUrl } from '../../constants'
import { softwareExplainedUrl } from '../../constants'
{/*import classNames from 'classnames'
import { Button } from '../uiLib'*/}

const MDARSSoftwareValidSubscription = ({ t, i18n }) => (
  <div className="content">
    <div className="m-b-md">{t('common:mdars-page-content-12')}
      <ul>
        <li>{t('common:mdars-page-content-68')}</li>
        <li>{t('common:mdars-page-content-69')}</li>
      </ul>
    </div>
    <h4 className="is-size-4 m-b-md">{t('common:mdars-page-subtitle')}</h4>
    <p><a href={softwareExplainedUrl(i18n.language)} target="_blank">{t('common:subscription-common')}</a></p>
    <div className="m-b-md">
      {/*<form action="https://mazda.mobile.grade-x.com" target="_blank">
      <Button
        outlined
        className={classNames({
          'is-default': true
        })}
        btType="default"        
      >
        {t('common:open-mdars')}
      </Button>
      </form>      */}
    </div>
    <div className="m-b-md">
      <ul>
        <li>
          <a href={mdarsDownloadInstructionsUrl(i18n.language)}
            target="_blank">
            {t('common:click-here')}
          </a> {t('common:mdars-page-content-6')}
        </li>
        <li>
          {t('common:ids-page-content-21')}&nbsp;
          <a href={mdarsUserManualUrl(i18n.language)}
            target="_blank">
            {t('common:here')}
          </a>
        </li>
        <li>          
          <a href={mdarsProgrammingManualUrl(i18n.language)}
            target="_blank">
            {t('common:mdars-page-content-45')}
          </a>
        </li>
        <li>{t('common:mdars-page-content-15')}   
          <a href="https://mazda.mobile.grade-x.com"
            target="_blank">
            https://mazda.mobile.grade-x.com
          </a>{t('common:mdars-page-content-19')}
        </li>
        <li>{t('common:mdars-page-content-67')}</li> 
            <li>{t('common:mdars-page-content-16')} <a href="https://s3.amazonaws.com/tsd.mazdausa.com/IDS/VCM-II Driver Setup.exe" target="_blank">{t('common:click-here')}</a> {t('common:mdars-page-content-35')}</li>
      </ul>
    </div>
    <div className="m-b-md">
      {t('common:mdars-page-content-7')}
      <div className="columns">
        <div className="column is-4">
      <ul>
            <li>{t('common:mdars-page-content-23')}</li>
            <li>{t('common:mdars-page-content-22')}</li>
            <li>{t('common:mdars-page-content-24')}</li>                    
            <li>{t('common:mdars-page-content-36')}</li>
          </ul>
        </div>
        <div className="column is-4">
          <ul>
            <li>{t('common:mdars-page-content-21')}</li>
            <li>{t('common:mdars-page-content-20')}</li>
            <li>{t('common:mdars-page-content-18')}</li>
            <li>{t('common:mdars-page-content-37')}</li>
          </ul>
        </div>
        <div className="column is-4">
          <ul>
            <li>{t('common:mdars-page-content-17')}</li>
            <li>{t('common:mdars-page-content-9')}</li>
            <li>{t('common:mdars-page-content-8')}</li>
            <li>{t('common:mdars-page-content-38')}</li>
      </ul>
        </div>
      </div>
    </div>

    <h4 className="is-size-4 m-b-md">{t('common:mdars-page-subtitle-2')}</h4>
    <div className="m-b-md">      
      <ul>
        <li><a href={mdarsIIRequirementsUrl(i18n.language)} target="_blank">{t('common:click-here')}</a> {t('common:mdars-page-content-29')}</li>
        <li>{t('common:mdars-page-content-30')} <a href="https://static.scantool.denso.info/mdarsii/users-guide/en/index.html" target="_blank">{t('common:click-here')}</a></li>
        <li><strong>{t('common:mdars-page-content-31')}</strong> {t('common:mdars-page-content-32')}</li>
      </ul>
    </div>

    <div className="m-b-md">{t('common:mdars-page-content-12')}
      <ul>
        <li>{t('common:mdars-page-content-39')}</li>        
      </ul>
    </div>

    <div className="m-b-md">
      <div>{t('common:mdars-page-content-25')}</div>
      <ul>
        <li>{t('common:mdars-page-content-26')}</li>
      </ul>
    </div>

    <h4 className="is-size-4 m-b-md">{t('common:mdars-page-content-2')}</h4>
    <div className="m-b-md">
      <div>{t('common:mdars-page-content-27')}</div>      
    </div>
    <div className="m-b-md">{t('common:mdars-page-content-12')}
      <ul>
        <li>{t('common:mdars-page-content-40')}</li>
        <li>{t('common:mdars-page-content-33')} <a href={densoManualUrl(i18n.language)} target="_blank">{t('common:click-here')}</a> {t('common:mdars-page-content-34')}</li>
        <li>{t('common:mdars-page-content-41')}</li>
      </ul>
    </div>


    <div className="m-b-md">
      <table className="table is-bordered login-history-list">
        <thead>
          <tr>
            <th colSpan="2">{t('common:mdars-page-content-28')}</th>
          </tr>
        </thead>
        <tbody>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-42')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-43')}</td>
          </tr>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-44')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-46')}</td>
          </tr>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-47')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-48')}</td>
          </tr>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-49')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-50')}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="m-b-md">
      <table className="table is-bordered login-history-list">
        <thead>
          <tr>
            <th colSpan="2">{t('common:mdars-page-content-51')}</th>
          </tr>
        </thead>
        <tbody>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-52')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-53')}<br />{t('common:mdars-page-content-54')}</td>
          </tr>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-55')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-56')}</td>
          </tr>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-57')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-58')}<br />{t('common:mdars-page-content-59')}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="m-b-md">
      {t('common:mdars-page-content-60')}
      <ul>
        <li>{t('common:mdars-page-content-61')}</li>
        <li>{t('common:mdars-page-content-62')}</li>
        <li>{t('common:mdars-page-content-63')}</li>
      </ul>
    </div>

    <div className="m-b-md">
      {t('common:mdars-page-content-64')}
      <ul>
        <li>{t('common:mdars-page-content-65')}</li>
        <li>{t('common:mdars-page-content-66')}</li>
      </ul>
    </div>

  </div>
)

export default MDARSSoftwareValidSubscription



// WEBPACK FOOTER //
// ./components/MDARSSoftware/WithValidSubscription.js